/**
 * @author Sarthak Sharma.
 * @since 02-01-2024.
 * @type {string} Users action types.
 */

export const SET_LOADING = '[ARTIST_USER] SET_LOADING';
export const SET_SHOWCASE_ARTISTS_LIST = '[ARTIST_USER] SET_SHOWCASE_ARTISTS_LIST';
export const APPEND_SHOWCASE_ARTISTS_LIST = '[ARTIST_USER] APPEND_SHOWCASE_ARTISTS_LIST';
export const SET_SHOWCASE_ARTISTS_LIST_META = '[ARTIST_USER] SET_SHOWCASE_ARTISTS_LIST_META';

export const SET_FAVORITE_DIRECTORS_LIST = '[ARTIST_USER] SET_FAVORITE_DIRECTORS_LIST';
export const APPEND_FAVORITE_DIRECTORS_LIST = '[ARTIST_USER] APPEND_FAVORITE_DIRECTORS_LIST';
export const SET_FAVORITE_DIRECTORS_LIST_META = '[ARTIST_USER] SET_FAVORITE_DIRECTORS_LIST_META';

export const SET_ACTIVE_AUDITION_LIST = '[ARTIST_USER] SET_ACTIVE_AUDITION_LIST';
export const APPEND_ACTIVE_AUDITION_LIST = '[ARTIST_USER] APPEND_ACTIVE_AUDITION_LIST';
export const SET_ACTIVE_AUDITION_LIST_META = '[ARTIST_USER] SET_ACTIVE_AUDITION_LIST_META';
export const SET_PAST_AUDITION_LIST = '[ARTIST_USER] SET_PAST_AUDITION_LIST';
export const APPEND_PAST_AUDITION_LIST = '[ARTIST_USER] APPEND_PAST_AUDITION_LIST';
export const SET_PAST_AUDITION_LIST_META = '[ARTIST_USER] SET_SHORTLISTED_JOB_LIST_META';

export const SET_SELECTED_DIRECTOR = '[ARTIST_USER] SET_SELECTED_DIRECTOR';
export const SET_SELECTED_DIRECTOR_META = '[ARTIST_USER] SET_SELECTED_DIRECTOR_META';

export const SET_IS_SELECT_MODE = '[ARTIST_USER] SET_IS_SELECT_MODE';
export const SET_LIST_TYPE = '[ARTIST_USER] SET_LIST_TYPE';

export const SET_USER_IMAGES = '[ARTIST_USER] SET_USER_IMAGES';

